import { easyTemplates } from "../easy_templates.js";
import { mediumTemplates } from "../medium_templates.js";
import { hardTemplates } from "../hard_templates.js";
import { brutalTemplates } from "../brutal_templates.js";
import { insaneTemplates } from "../insane_templates.js";
import { defineProceduralMap } from "./_helpers.js";

// The original game: every hazard, every layout, mapped 1:1 onto the five
// difficulty tiers. This is the default map and reproduces the pre-maps
// behavior exactly (easyTemplates already contains flat_ground; the core
// merge re-adds an identical copy, so nothing changes).
export const classicMap = defineProceduralMap({
  id: "classic",
  name: "Classic Marathon",
  description: "The original endless mix of spikes, pits, lasers, and bullets.",
  tiers: {
    level1: easyTemplates,
    level2: mediumTemplates,
    level3: hardTemplates,
    level4: brutalTemplates,
    level5: insaneTemplates,
  },
});
